import { remoteConfig } from "../config/firebase";
import { fetchAndActivate, getAll, getValue } from "firebase/remote-config";

const RemoteConfigService = {
  // Fetches remote config parameters
  async fetchRemoteConfig() {
    try {
      // Configure remote config settings
      remoteConfig.settings = {
        minimumFetchIntervalMillis: 3600 * 1000, // 1 hour
        fetchTimeoutMillis: 10000, // 10 seconds timeout
      };

      // Optionally set default values (if needed)
      // remoteConfig.defaultConfig = { example_key: "default_value" };

      await fetchAndActivate(remoteConfig);

      const config = getAll(remoteConfig);
      return Object.fromEntries(
        Object.entries(config).map(([key, value]) => [key, value.asString()])
      );
    } catch (error) {
      console.error("Failed to fetch remote config:", error);
      // Optionally, return an empty object or handle fallback logic here
      throw error;
    }
  },

  // Get a specific remote config parameter
  getParameter(key) {
    return getValue(remoteConfig, key).asString();
  },
};

export default RemoteConfigService;
